import { createTheme } from '@mui/material';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const darkPalette = clientThemePalette[CLIENT_THEME].dark;
const palette = clientThemePalette[CLIENT_THEME].light;

declare module '@mui/material/styles' {
  interface Palette {
    customBackground?: {
      section: string;
      modal: string;
    };
  }
  interface PaletteOptions {
    customBackground?: {
      section: string;
      modal: string;
    };
  }
}

// Common component styles shared between themes
const componentOverrides = {
  MuiTab: {
    styleOverrides: {
      root: {
        color: 'text.secondary',
        '&.Mui-selected': {
          color: 'primary.main',
        },
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        fontWeight: 500,

        '&.Mui-selected': {
          backgroundColor: palette.primary,
          color: '#fff',
        },

        '&.Mui-selected:hover': {
          backgroundColor: palette.primary,
        },
      },
    },
  },
};

const fontFamily = 'Poppins';

// 1. Define the Dark Theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: darkPalette.primary,
    },
    background: {
      default: darkPalette.paperBackground,
      paper: darkPalette.paperBackground,
    },
    customBackground: {
      section: darkPalette.sectionBackground,
      modal: darkPalette.paperBackground,
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5',
    },
    svgIcons: {
      primary: {
        fill: darkPalette.primary,
      },
      error: {
        fill: '#A03434',
      },
    },
  },
  components: {
    ...componentOverrides,
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: darkPalette.toolBarBackground,
        },
      },
    },
  },
  typography: {
    fontFamily,
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: palette.primary,
    },
    customBackground: {
      section: '#EEEEEE',
      modal: '#FFFFFF',
    },
    text: {
      secondary: '#616161',
    },
    svgIcons: {
      primary: {
        fill: '#1049E5',
      },
      error: {
        fill: '#A03434',
      },
    },
  },
  components: {
    ...componentOverrides,
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5', // Light grey
        },
      },
    },
  },
  typography: {
    fontFamily,
  },
});
